import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
  } from "@azure/msal-react";
  import LayoutTop from "./LayoutTop";
  import LayoutBottom from "./LayoutBottom";
  import LoginPage from "../../Pages/LoginPage";
  
  import InnerPageLayoutBody from "./InnerPageLayoutBody";
  import { Col, Container, Row } from "react-bootstrap";
  
  interface IProps {
    children: JSX.Element;
  }
  function InnerPageLayout(props: IProps) {
  
    // const user = app.user || { displayName: '', jobTitle: '' };
  
    return (
      <>

            <AuthenticatedTemplate>
              <>
     
                <Container className="  bg-white wrapper06 shadow overflow-hidden    rounded-3"         style={{ marginTop: "30px" }}>
                  <Row className="centered-layout2">

  
                    <Col md={12} className="bg-white">

                      <div className="centered-layout">
                        <LayoutTop />
                        <div className="container-fluid"   style={{ marginTop: "10px" }}>
                          <div className="witemBody">
                            <div className="row g-0 justify-content-center p-4">
                            
                              {props.children}
                            </div>
                          </div>
                        </div>
                      </div>
                      <LayoutBottom />
                    </Col>
                  </Row>
                </Container>
              </>
            </AuthenticatedTemplate>
  
       
  
        <UnauthenticatedTemplate>
          <LoginPage />
        </UnauthenticatedTemplate>
      </>
    );
  }
  
  export default InnerPageLayout;
  